const LoginSessionKey = 'loginSession'
const UserInfoKey = 'userInfo'
const ShopInfoKey = 'shopInfo'
const JPUSH_ID = 'JPUSH_ID'

let loginSession = {
  key: '',
  session: '',
  token: '',
  uid: '',
  uuid: ''
}
/**
 * 获取存储的登录 session
 * @return {JSON} loginSession 存储的登录 session
 */
export const getLoginSessionLocalStorage = () => {
  try {
    return JSON.parse(window.localStorage.getItem(LoginSessionKey))
  } catch (e) {
    console.log(e)
  }
}
/**
 * 设置并存储登录 session
 * @param {string} key 会话标志符
 * @param {string} session 用户session
 * @param {string} token 会话令牌
 * @param {string} uid 用户ID
 * @param {string} uuid 设备ID
 */
export const setLoginSessionLocalStorage =
(key = '', session = '', token = '', uid = '', uuid = '') => {
  loginSession.key = key
  loginSession.session = session
  loginSession.token = token
  loginSession.uid = uid
  loginSession.uuid = uuid

  return window.localStorage.setItem(LoginSessionKey, JSON.stringify(loginSession))
}
/**
 * 清空存储的登录 session
 */
export const removeLoginSessionLocalStorage = () => {
  window.localStorage.removeItem(LoginSessionKey)
}

// --------------- User Info ---------------
/**
 * 存储用户常用信息
 * @param {string} userInfo 用户信息
 *      userInfo: {
 *          sex: 0,
 *          avatar: '',
 *          nick: '',
 *          address: '',
 *          info: '',
 *          birthday: '',
 *          identity: '',
 *      }
 */
export const setUserInfoLocalStorage = (userInfo) => {
  window.localStorage.setItem(UserInfoKey, userInfo)
}
/**
 * 获取用户常用信息
 * @return {string} userInfo 用户信息
 */
export const getUserInfoLocalStorage = () => {
  return window.localStorage.getItem(UserInfoKey)
}

// --------------- 商户信息 ---------------
export const setShopInfoLocalStorage = (shopInfo) => {
  window.localStorage.setItem(ShopInfoKey, shopInfo)
}
/**
 * 获取商户常用信息
 * @return {string} shopInfo 商户信息
 */
export const getShopInfoLocalStorage = () => {
  return window.localStorage.getItem(ShopInfoKey)
}

export const setJPushID = (rId) => {
  window.localStorage.setItem(JPUSH_ID, rId)
}

export const getJPushID = (rId) => {
  return window.localStorage.getItem(JPUSH_ID)
}



// WEBPACK FOOTER //
// ./src/assets/js/localStorage.js